import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useToast } from "../contexts/ToastContext";
import Button from "../components/Button";
import "./scss/manager-auth.scss";

export default function ManagerAuthPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const { showToast } = useToast();

  const [loginValue, setLoginValue] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!loginValue || !password) {
      showToast("Заполните логин и пароль");
      return;
    }

    try {
      setLoading(true);
      await login("manager", loginValue, password);
      navigate("/manager/dashboard");
    } catch {
      showToast("Неверный логин или пароль");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="manager-auth-page">
      <div className="manager-auth-page__container">
        <div className="manager-auth-page__card">

          <div className="manager-auth-page__logo">
            <img src="/images/floyaLogo.png" alt="Floya" />
            <span>Для менеджеров</span>
          </div>

          <div className="manager-auth-page__form">
            <input
              placeholder="Логин"
              value={loginValue}
              onChange={(e) => setLoginValue(e.target.value)}
            />

            <input
              type="password"
              placeholder="Пароль"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <Button
              className="btn-primary large"
              onClick={handleSubmit}
              load={loading}
            >
              Войти в аккаунт
            </Button>
          </div>

        </div>
      </div>
    </div>
  );
}